import { useMutation } from "@tanstack/react-query";
import FetchClients, { ClientOutput } from "../client";
import { throwBackpackResponseError } from "../errors";

type SiteVisitRequest = ClientOutput["rewards"]["SiteVisitRequest"];
const siteVisit = {
  usePost,
} as const;

export default siteVisit;

function usePost({ user_key, site_id }: { user_key: string; site_id: number }) {
  return useMutation({
    mutationFn: async (body: SiteVisitRequest) => {
      const { data, error } = await FetchClients.rewards.POST("/site-visit", {
        params: {
          query: {
            user_key,
            id: site_id,
          },
        },
        body,
      });
      if (data) return data;
      throwBackpackResponseError(error);
    },
  });
}
